import React, {
  ReactElement, useState,
} from 'react';
import {
  DatePicker, FormGroup, Label, Select,
} from 'idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import CiselnikPolozkaSelect from './CiselnikPolozkaSelect';
import MultiSelectWithTreeForOblast from '../../../MultiSelectWithTreeForOblast';
import {
  lpStadiumMaterialuValues,
  piStadiumMaterialuValues,
} from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import PolozkaCiselnik from '../../../../model/ciselniky/PolozkaCiselnik';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import SearchInput from './SearchInput';
import './sidePanel.scss';
import InstituciaSingleSelect from './InstituciaSingleSelect';
import PredkladatelSingleSelect from './PredkladatelSingleSelect';

interface Props {
  isPredbezna?: boolean;
  filter: LegMaterialListFilter;
  onUpdateField?: SafeParameterSetter<LegMaterialListFilter>;
  filterCopy: LegMaterialListFilter;
  onUpdateFieldCopy: SafeParameterSetter<LegMaterialListFilter>;
  setFilter: (filter: LegMaterialListFilter) => void;
}

const MobileFilters = ({
  isPredbezna = false,
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => {
  const [executeTyp, setExecuteTyp] = useState(!!filter.typ);
  const stadiumList = isPredbezna ? piStadiumMaterialuValues : lpStadiumMaterialuValues;
  return (
    <div className="legislativny-material-list-side-panel">
      <ExpansionPanel
        className="stadium-procesu-container"
        title="Štádium materiálu"
      >
        <Select
          id="stadium"
          name="stadium"
          width="full"
          onChange={({ target }) => {
            onUpdateField('stadium', target.value === 'Vyberte' ? null : target.value);
          }}
          value={filter.stadium ? filter.stadium : ''}
        >
          <option>Vyberte</option>
          {(Array.from(stadiumList) && Array.from(stadiumList)?.length > 0) ? (
            <>
              {Array.from(stadiumList)
                .sort(([, aStadium], [, bStadium]) => aStadium.nazov.localeCompare(bStadium.nazov))
                .map(([stadiumEnum, stadium]) => (
                  <option key={stadiumEnum} value={stadiumEnum}>{stadium.nazov}</option>
                ))}
            </>
          ) : (
            <option key="emptyOption" value="emptyOption" disabled>
              Nenašiel sa žiadny záznam.
            </option>
          )}
        </Select>
      </ExpansionPanel>
      <ExpansionPanel
        title="Číslo procesu"
      >
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextCislo}
          fieldName="searchTextCislo"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
        />
      </ExpansionPanel>
      <ExpansionPanel
        title="Názov materiálu"
      >
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextNazov}
          fieldName="searchTextNazov"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
        />
      </ExpansionPanel>

      {!isPredbezna && (
        <ExpansionPanel
          title="Typ materiálu"
          onExpand={() => setExecuteTyp(true)}
        >
          <CiselnikPolozkaSelect
            execute={executeTyp}
            setTyp={(newValue: PolozkaCiselnik) => onUpdateField('typ', newValue)}
            selectedTypKod={filter?.typ?.kod}
            typCiselnikaEnum={TypCiselnikaEnum.TypMaterialu}
            fieldName="typMaterialu"
            predbeznaInformacia={isPredbezna}
          />
        </ExpansionPanel>
      )}
      <MultiSelectWithTreeForOblast
        isExpanded={false}
        oblastList={filter.oblastList}
        onUpdateField={onUpdateField}
        showItemList={false}
      />
      <ExpansionPanel
        title="Rezortné číslo"
      >
        <SearchInput
          filterSearchText={filterCopy?.searchTextRezort}
          fieldName="searchTextRezort"
          onUpdateFieldCopy={onUpdateFieldCopy}
          filterCopy={filterCopy}
          setFilter={setFilter}
        />
      </ExpansionPanel>
      <ExpansionPanel
        title="Ročník"
      >
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextRocnik}
          fieldName="searchTextRocnik"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
          type="search-number"
          maxLength={4}
        />
      </ExpansionPanel>
      <PredkladatelSingleSelect
        isExpanded={false}
        onUpdateField={onUpdateField}
        onUpdateFieldCopy={onUpdateFieldCopy}
        filterCopy={filterCopy}
        filter={filter}
      />
      <InstituciaSingleSelect
        isExpanded={false}
        onUpdateField={onUpdateField}
        onUpdateFieldCopy={onUpdateFieldCopy}
        filterCopy={filterCopy}
        filter={filter}
      />
      <ExpansionPanel
        title="Dátum zmeny"
      >
        <FormGroup>
          <FormGroup>
            <Label htmlFor="zmenaOd">Zmena od</Label>
            <DatePicker
              id="zmenaOd"
              showIcon
              value={filter?.datumZmenyOd}
              onChange={date => onUpdateField('datumZmenyOd', date)}
              strictParsing
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="zmenaOd">Zmena do</Label>
            <DatePicker
              id="zmenaDo"
              showIcon
              value={filter?.datumZmenyDo}
              onChange={date => onUpdateField('datumZmenyDo', date)}
              strictParsing
            />
          </FormGroup>
        </FormGroup>
      </ExpansionPanel>
    </div>
  );
};

export default MobileFilters;
